import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ss",
  "use": "icon-icon-ss-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ss\">\n  <path fill=\"#078930\" d=\"M0 358.4h512V512H0z\" />\n  <path fill=\"#fff\" d=\"M0 153.6h512v204.8H0z\" />\n  <path d=\"M0 0h512v153.6H0z\" />\n  <path fill=\"#da121a\" d=\"M0 179.2h512v153.6H0z\" />\n  <path fill=\"#0f47af\" d=\"m0 0 433 256L0 512z\" />\n  <path fill=\"#fcdd09\" d=\"M209 207.8 64.4 256l144.8 48.1-89.5-126v155.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol